import React from "react";
import styles from "./ActionButton.module.css";

const ActionButton = ({ text, onClick, isDisable }) => {
  return (
    <div className={styles.buttonContainer}>
      <button
        className={`${styles.button} ${isDisable ? styles.disable : ""}`}
        onClick={() => {
          if (!isDisable) {
            onClick();
          }
        }}
      >
        {text}
      </button>
    </div>
  );
};

export default ActionButton;
